import WaybillNoExportExportItem from "../enum/WaybillNoExportExportItem";

const WaybillNoExportExportItemNameMap = {
    [WaybillNoExportExportItem.LOGISTIC_COMPANY]: "快递公司",
    [WaybillNoExportExportItem.WAYBILL_NO]: "快递单号",
    [WaybillNoExportExportItem.PARENT_WAYBILL_NO]: "母单号",
    [WaybillNoExportExportItem.EWAYBILL_BRANCH_INFO]: "网点",
    [WaybillNoExportExportItem.WAYBILL_TEMPLATE_NAME]: "快递单模板名称",
    [WaybillNoExportExportItem.POSTAGE]: "邮费（元）",
    [WaybillNoExportExportItem.WEIGHT]: "重量（千克）",
    [WaybillNoExportExportItem.PRINT_TIME]: "打印时间",
    [WaybillNoExportExportItem.NAME]: "收货人",
    [WaybillNoExportExportItem.MOBILE]: "收货手机",
    [WaybillNoExportExportItem.TELEPHONE]: "收货电话",
    [WaybillNoExportExportItem.PROVINCE]: "收货省",
    [WaybillNoExportExportItem.CITY]: "收货市",
    [WaybillNoExportExportItem.DISTRICT]: "收货区",
    [WaybillNoExportExportItem.TOWN]: "收货街道",
    [WaybillNoExportExportItem.ZIP_CODE]: "邮编",
    [WaybillNoExportExportItem.SHOP_NAME]: "店铺名称",
    [WaybillNoExportExportItem.RETAILER_SHOP_NAME]: "代理商",
    [WaybillNoExportExportItem.ORDER_ORIGINAL_ID]: "订单号",
    [WaybillNoExportExportItem.SHIPPING_TIME]: "发货时间",
    [WaybillNoExportExportItem.ORDER_SELLER_REMARK]: "订单备注",
    [WaybillNoExportExportItem.PRODUCT_TITLE]: "商品标题",
    [WaybillNoExportExportItem.PRODUCT_EXTERNAL_ID]: "商品编码",
    [WaybillNoExportExportItem.SKU_EXTERNAL_ID]: "SKU编码",
    [WaybillNoExportExportItem.SKU_PROPERTIES_NAME]: "商品属性",
    [WaybillNoExportExportItem.SKU_QUANTITY]: "商品数量",
    [WaybillNoExportExportItem.SKU_WEIGHT]: "商品总重量（千克）",
    [WaybillNoExportExportItem.ORDER_TIME]: "下单时间",
    [WaybillNoExportExportItem.BUYER_NICKNAME]: "买家（代理商）昵称",
};

export default WaybillNoExportExportItemNameMap;
